"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.elementToText = void 0;

var React = _interopRequireWildcard(require("react"));

var elementToText = function elementToText(el) {
  if (React.isValidElement(el)) {
    if (!(el && el.props && el.props.children)) {
      return '';
    }

    return React.Children.toArray(el.props.children).reduce(function (result, child) {
      if (typeof child === 'string') {
        return result + child;
      } else if (React.isValidElement(child)) {
        return result + elementToText(child);
      }

      return result;
    }, '');
  }

  return '';
};

exports.elementToText = elementToText;
//# sourceMappingURL=utils.js.map